<template>
    <div v-if="$auth.ready()">
        <header-navigation />
        <transition name="fade" mode="out-in">
            <router-view />
        </transition>

        <message-modal />
    </div>

    <div v-else class="position-absolute vh-100 vw-100 d-flex flex-column justify-content-center align-items-center">
        <b-spinner style="width: 5rem; height: 5rem;"/>
        <p class="mt-3">{{ $t('Loading application') }}</p>
    </div>
</template>

<script>
    import HeaderNavigation from "@/components/layout/HeaderNavigation";
    import MessageModal from "@/components/issues/MessageModal";
    export default {
        name: "App",
        components: {MessageModal, HeaderNavigation}
    }
</script>
